import { render, staticRenderFns } from "./ObjectiveName.vue?vue&type=template&id=728f827e&scoped=true"
import script from "./ObjectiveName.vue?vue&type=script&lang=ts&setup=true"
export * from "./ObjectiveName.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ObjectiveName.vue?vue&type=style&index=0&id=728f827e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f827e",
  null
  
)

export default component.exports